import type { z } from 'zod'
import { nativeEnum } from 'zod'
import { PermissionType } from '@library/enums'
import { getPermissionDataSchema } from '@library/utils/zod'

/** 權限型別 */
export const permissionDataSchema = getPermissionDataSchema(
  nativeEnum(PermissionType)
)

export interface PermissionData extends z.infer<typeof permissionDataSchema> {}
